import gql from 'graphql-tag';

const RESEND_CONFIRMATION_CODE = gql`
    query resendConfirmationCode($email: String) {
        resendConfirmationCode(email: $email) {
            internalCode
        }
    }
`;

export default RESEND_CONFIRMATION_CODE;
